import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    api
      .post("/auth/google/session", { session_id: sessionId })
      .then((res) => {
        setUser(res.data);
        window.history.replaceState(null, "", location.pathname);
        navigate("/", { replace: true, state: { user: res.data } });
      })
      .catch((err) => {
        toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Google ile giriş başarısız");
        setUser(false);
        window.history.replaceState(null, "", "/login");
        navigate("/login", { replace: true });
      });
  }, [location, navigate, setUser]);

  return null;
}
